/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import {
  color,
  desktopVW,
  mobileVW, minTablet, maxTablet,

} from '../../styles';
import { Typography } from '../../shared/Typography';

export const Card = ({
  children, title, description, secondaryTitle,
} : any) => (
  <StyledCard>
    <StyledTypography size="is-xs" variants="h3">
      {secondaryTitle ? (
        <>
          <span>{title}</span>
          <span>{secondaryTitle}</span>
        </>
      ) : title}
    </StyledTypography>
    {description && (
      <p>{parse(description)}</p>
    )}
    {children}
  </StyledCard>
);

const StyledCard = styled.section`
  background: ${color.white};
  border-radius: ${mobileVW(10)};
  padding: ${mobileVW(60)} ${mobileVW(15)};

  & + & {
    margin-top: ${mobileVW(30)};
  }

  ${minTablet} {
    border-radius: ${desktopVW(10)};
    padding: ${desktopVW(60)};

    & + & {
      margin-top: ${desktopVW(30)};
    }
  }
`;

const StyledTypography = styled(Typography)`
  font-size: ${mobileVW(20)};


  ${minTablet} {
    display: flex;
    justify-content: space-between;
    font-size: ${desktopVW(24)};
  }

  span:last-child {
    color: ${color.blue};

    ${maxTablet} {
      display: block;
    }
  }
`;
